import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const LANDSURFACETEMPERATURE_LAYER_ID = 'landSurfaceTemperatureLayer';

const layerConfig = {
  title: 'Land Surface Temperature',
};

function LandSurfaceTemperatureLayer() {
  const dispatch = useDispatch();
  const { landSurfaceTemperatureLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, landSurfaceTemperatureLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (landSurfaceTemperatureLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: LANDSURFACETEMPERATURE_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: landSurfaceTemperatureLayer.visible,
      opacity: landSurfaceTemperatureLayer.opacity,

      getFillColor: colorBins({
        attr: 'Temperature_Fahrenheit',
        domain: [55, 58, 63, 68, 70],
        colors: [
          [236, 218, 154],
          [239, 196, 126],
          [243, 173, 106],
          [247, 148, 93],
          [249, 123, 87],
          [246, 99, 86],
        ],
      }),
      pointRadiusMinPixels: 3.5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: LANDSURFACETEMPERATURE_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['Temperature_Fahrenheit', 'Land_Area_Square_Feet'],
            }),
          };
        }
      },
    });
  }
}

export default LandSurfaceTemperatureLayer;
